import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PermissionsActions } from "../../store/ducks/permissions";
import { Creators as ModalVideosActions } from "../../store/ducks/modalVideos";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../services/auth";
import Sidebar from "../Sidebar";
import Header from "../Header";
import HeaderMenuHorizontal from "../HeaderMenuHorizontal";
import Footer from "../Footer";
import { Container, Wrapper } from "./styles.js";
import { withStyles } from "@material-ui/core/styles";
import compose from "recompose/compose";
import classNames from "classnames";
import Fade from "@material-ui/core/Fade";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../Loading";
import ErrorBoundary from "../../components/ErrorBoundary";
import Modal from "../../components/DraggableModal";
import MinimizeButton from "@material-ui/icons/Remove";
import IconButton from "@material-ui/core/IconButton";
import Calculadora from "../../components/Calculadora";
import ChatContainer from "../../components/ChatContainer";

import SuccessImportacoes from "../../components/SuccessImportacoes";

import { Provider } from "react-redux";
import store from "../../storeChat";

/** MINIMIZAVEIS */
import ClientesForm from "../../components/Forms/Clientes";
import PropostasForm from "../../components/Forms/Propostas";
import { Creators as ModaisMinimizadosActions } from "../../store/ducks/modaisMinimizados";

import { Creators as StoreClientesPageActions } from "../../store/ducks/PageStores/clientesStores";
import { Creators as ClientesActions } from "../../store/ducks/clientes";
import { Creators as AuthActions } from "../../store/ducks/auth";
import { Creators as ModalCadastroClientesActions } from "../../store/ducks/modalCadastroClientes";
import { Creators as ModalEdicaoClientesActions } from "../../store/ducks/modalEdicaoClientes";

import { Creators as StorePropostasPageActions } from "../../store/ducks/PageStores/propostasStores";
import { Creators as PropostasActions } from "../../store/ducks/propostas";
import { Creators as ModalCadastroPropostasActions } from "../../store/ducks/modalCadastroPropostas";
import { Creators as ModalEdicaoPropostasActions } from "../../store/ducks/modalEdicaoPropostas";

const tenant = localStorage.getItem("@ecorban-app:tenant");

const styles = (theme) => ({
  "contentShift-left": {
    marginLeft: 0,
  },
  transition: {
    transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important",
  },
});

class PrivateRoute extends Component {
  componentDidMount() {
    let token = localStorage.getItem("@ecorban-app:token");
    this.setState({ fade: true });
    if (token !== null) {
      this.props.getPermissions();
    } else {
      console.log("force redirect to login and stop execution");
      this.props.logout();
    }
  }

  handleMinimize = (title, funcMax, funcClose) => {
    let n = this.props.modaisMinimizados.filter(
      (modal) => modal.title !== title
    );
    let pivot = [...n, { title, funcMax, funcClose }];
    this.props.addModal(pivot);
    funcClose();
  };

  handleEditClientes = (id) => {
    this.props.setClienteAction("EDIT");
    this.props.getClientes(id);
  };

  render() {
    const { component: Component, classes, open, fit, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() ? (
            <Fade in={this.props.totalPermissions > 0}>
              {this.props.totalPermissions > 0 ? (
                <div className="wrapper">
                  <SuccessImportacoes />
                  {this.props.menu === "vertical" && <Sidebar />}
                  <Container
                    className={classNames(
                      classes.content,
                      {
                        [`content-left`]: !fit,
                        [`content-left-fit`]: fit,
                      },
                      {
                        [classes[`transition`]]: true,
                        [classes[`contentShift-left`]]: open,
                      }
                    )}
                  >
                    {this.props.menu === "vertical" ? (
                      <Header />
                    ) : (
                      <HeaderMenuHorizontal />
                    )}
                    <Scrollbars
                      id={
                        this.props.page !== "Propostas"
                          ? this.props.content
                          : "main-content"
                      }
                      className="d-flex"
                    >
                      <Wrapper>
                        <ErrorBoundary>
                          <Component {...props} />
                        </ErrorBoundary>
                      </Wrapper>
                    </Scrollbars>
                    <Footer />
                    <Modal
                      open={
                        this.props.modalCadastroClientes
                          .openModalCadastroClientes
                      }
                      handleCloseModalClientes
                      onClose={this.props.closeModalCadastroClientes}
                      className="modal modal-minimizavel"
                    >
                      <div>
                        <div className="modalHeader">
                          Cadastrar cliente
                          <IconButton
                            onClick={() =>
                              this.handleMinimize(
                                "Cadastrar cliente",
                                this.props.openModalCadastroClientes,
                                this.props.closeModalCadastroClientes
                              )
                            }
                            className="mr1 text-button"
                          >
                            <MinimizeButton />
                          </IconButton>
                        </div>
                        <div className="modalBody modal-clientes">
                          <ClientesForm
                            handleClose={this.props.closeModalCadastroClientes}
                            handleEdit={this.handleEditClientes}
                          />
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      open={
                        this.props.modalEdicaoClientes.openModalEdicaoClientes
                      }
                      onClose={this.props.closeModalEdicaoClientes}
                      className="modal modal-minimizavel"
                    >
                      <div>
                        <div className="modalHeader">
                          {this.props.clientesStores.action === "EDIT" &&
                            "Editar cliente"}
                          {this.props.clientesStores.action === "DETAIL" &&
                            "Detalhes do cliente"}
                          <IconButton
                            onClick={() =>
                              this.handleMinimize(
                                this.props.clientesStores.action === "EDIT"
                                  ? "Editar cliente"
                                  : "Detalhes do cliente",
                                this.props.openModalEdicaoClientes,
                                this.props.closeModalEdicaoClientes
                              )
                            }
                            className="mr1 text-button"
                          >
                            <MinimizeButton />
                          </IconButton>
                        </div>
                        <div className="modalBody modal-clientes">
                          <ClientesForm
                            handleClose={this.props.closeModalEdicaoClientes}
                          />
                        </div>
                      </div>
                    </Modal>

                    <Modal
                      open={
                        this.props.modalCadastroPropostas
                          .openModalCadastroPropostas
                      }
                      onClose={this.props.closeModalCadastroPropostas}
                      className="modal modal-minimizavel"
                    >
                      <div>
                        <div className="modalHeader">
                          Cadastrar proposta
                          <IconButton
                            onClick={() =>
                              this.handleMinimize(
                                "Cadastrar proposta",
                                this.props.openModalCadastroPropostas,
                                this.props.closeModalCadastroPropostas
                              )
                            }
                            className="mr1 text-button"
                          >
                            <MinimizeButton />
                          </IconButton>
                        </div>
                        <div className="modalBody modal-propostas">
                          <PropostasForm
                            handleClose={this.props.closeModalCadastroPropostas}
                            handleEdit={this.handleEditPropostas}
                          />
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      open={
                        this.props.modalEdicaoPropostas.openModalEdicaoPropostas
                      }
                      onClose={this.props.closeModalEdicaoPropostas}
                      className="modal modal-minimizavel"
                    >
                      <div>
                        <div className="modalHeader">
                          {this.props.propostasStores.actionProposta ===
                            "EDIT" && "Editar proposta"}
                          {this.props.propostasStores.actionProposta ===
                            "DETAIL" && "Detalhes da proposta"}
                          <IconButton
                            onClick={() =>
                              this.handleMinimize(
                                this.props.propostasStores.actionProposta ===
                                  "EDIT"
                                  ? "Editar proposta"
                                  : "Detalhes da proposta",
                                this.props.openModalEdicaoPropostas,
                                this.props.closeModalEdicaoPropostas
                              )
                            }
                            className="mr1 text-button"
                          >
                            <MinimizeButton />
                          </IconButton>
                        </div>
                        <div className="modalBody modal-propostas">
                          <PropostasForm
                            handleClose={this.props.closeModalEdicaoPropostas}
                          />
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      open={this.props.modalVideos.open}
                      onClose={this.props.closeVideos}
                      className="modal"
                    >
                      <div>
                        <div className="modalHeader">
                          {this.props.modalVideos.title}
                        </div>
                        <div className="modalBody ">
                          <iframe
                            title="Videos Ajuda"
                            width="900"
                            height="506"
                            src={this.props.modalVideos.url}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                      </div>
                    </Modal>
                    {this.props.calculadora.openCalc && <Calculadora />}
                    {this.props.chat_key && (
                      <Provider store={store}>
                        <ChatContainer user={this.props.user} />
                      </Provider>
                    )}
                  </Container>
                </div>
              ) : (
                <Loading />
              )}
            </Fade>
          ) : (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.sidebar.open,
  fit: state.sidebar.fit,
  totalPermissions: state.permissions.data.length,
  modalCadastroClientes: state.modalCadastroClientes,
  modalEdicaoClientes: state.modalEdicaoClientes,
  modalCadastroPropostas: state.modalCadastroPropostas,
  modalEdicaoPropostas: state.modalEdicaoPropostas,
  modaisMinimizados: state.modaisMinimizados.data,
  propostasStores: state.propostasStores,
  clientesStores: state.clientesStores,
  modalVideos: state.modalVideos,
  menu: state.menu.disposicao,
  page: state.pages.currentPageName,
  content: state.content.disposicao,
  calculadora: state.calculadora,
  chat_key: state.permissions.chat_key,
  user: state.permissions,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...PermissionsActions,
      ...ModalCadastroClientesActions,
      ...ModalEdicaoClientesActions,
      ...ModaisMinimizadosActions,
      ...StoreClientesPageActions,
      ...ClientesActions,
      ...AuthActions,
      ...StorePropostasPageActions,
      ...PropostasActions,
      ...ModalCadastroPropostasActions,
      ...ModalEdicaoPropostasActions,
      ...ModalVideosActions,
    },
    dispatch
  );

export default compose(
  withStyles(styles, { name: "PrivateRoute" }),
  connect(mapStateToProps, mapDispatchToProps)
)(PrivateRoute);

connect(mapStateToProps)(styles);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js